import useGoBack from "./useGoBack";

export default function useRemoveTab() {
  const goBack = useGoBack();
  const handleRemoveTab = () => {
    goBack();
  };

  return { removeTab: handleRemoveTab };
}
